<p>An error occured</p>
<p>{{ error.text }}</p>
<p>{{ error.error }}</p>
